import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import type { ContextAction } from '@/store/headerStore'

interface HeaderContextBarProps {
  actions: ContextAction[]
}

export function HeaderContextBar({ actions }: HeaderContextBarProps) {
  if (actions.length === 0) return null

  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: 'auto', opacity: 1 }}
      exit={{ height: 0, opacity: 0 }}
      transition={{ duration: 0.2 }}
      className="border-b border-gray-100 bg-white/80 backdrop-blur-sm overflow-hidden"
    >
      <div className="flex items-center gap-2 px-4 py-2 overflow-x-auto scrollbar-hide">
        {actions.map((action) => {
          const Icon = action.icon
          return (
            <button
              key={action.id}
              onClick={action.onClick}
              className={cn(
                'px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors flex items-center gap-1.5',
                action.variant === 'primary' || action.isActive
                  ? 'bg-black text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              )}
            >
              {Icon && <Icon size={14} weight="bold" />}
              {action.label}
            </button>
          )
        })}
      </div>
    </motion.div>
  )
}
